import styled from 'styled-components';

export const StyledFormError = styled.div`
    color: #f15536;
    margin-top: -12px;
    font-size: 13px;
`
